angular.module('zc.agencies')
  .config(routerConfig);

routerConfig.$inject = ['$stateProvider'];
function routerConfig($stateProvider) {
  $stateProvider
    .state('admin.agencies', {
      abstract: true,
      url: '/agencies/{agencyName}',
      resolve: {
        agency: (Agency, $stateParams) => Agency.get(`name:${$stateParams.agencyName}`)
      }
    })
    .state('admin.agencies.settings', {
      url: '/settings',
      views: {
        'content@': {
          template: '<zc-agency-settings agency="$resolve.agency"></zc-agency-settings>',
          resolve: {
          }
        }
      },
    });
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/agencies/routes.js